// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8d86c8a","455":"15326a5f","977":"a6c8eddf"}[chunkId] + ".chunk.js";
};